import { createHighlighterCoreSync, createJavaScriptRegexEngine, LanguageRegistration, ThemeRegistrationAny } from 'shiki'
import './code.css'

export type CodeProps = {
  code: string
  lang: LanguageRegistration[]
  theme: ThemeRegistrationAny
  className?: string
}

export function Code (props: CodeProps) {
  const {
    code,
    lang,
    theme,
    className
  } = props

  const shiki = createHighlighterCoreSync({
    themes: [theme],
    langs: [lang],
    engine: createJavaScriptRegexEngine()
  })

  const langName = lang[0].name
  const themeName = theme.name || 'dracula'

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: shiki.codeToHtml(code, { lang: langName, theme: themeName })
      }}
    />
  )
}
